import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const initialState = {
  speech_points: Array(12).fill(false),
  documents: {
    passport: false,
    boarding_pass: false,
    entry_visa: false,
    credit_card: false,
    nova: false,
    payment_slips: false,
    invoice: false
  }
}

export const speechCheckListSlice = createSlice({
  name: 'speech_check_list',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    initializeSpeechCheckList: () => initialState,
    setSpeechPoints: (state, action) => {
      const { no, value } = action.payload
      state.speech_points[no] = value
    },
    setDocumentPoints: (state, action) => {
      const { name, value } = action.payload
      state.documents[name] = value
    }
  }
})

export const { setSpeechPoints, setDocumentPoints, initializeSpeechCheckList } =
  speechCheckListSlice.actions
export default speechCheckListSlice.reducer
